import { useContext } from 'react';
import Payu from '../../../../../../icons/payou.logo.svg';
import Lock from '../../../../../../icons/secured-lock.svg';
import Stripe from '../../../../../../icons/stripe.svg';
import Paddle from '../../../../../../icons/paddle-logo.png';
import styled from 'styled-components';
import {
	PADDLE_ONE_OFF,
	PAYU_OPERATOR_COUNTRIES,
	STRIPE_ONE_OFF,
	STRIPE_SUBSCRIBTION,
} from '../../../../../../Checkout';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { PAYMENTS_INFO_CONFIG } from '@/pages/checkouts/checkout/constants/payments-info-config.constants';

const PaymentIcon = styled.img`
	width: 60px;
`;

const ImageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
	max-height: 20px;

	border-radius: 5px;
	background: #fff;
	padding: 5px;
`;

const PaymentTitle = styled.p`
	color: #05275d;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: -0.32px;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

const SavePayment = () => {
	const { lang } = useContext(LanguageContext);
	const translations = useLanguageData('checkout');

	return (
		<>
			<PaymentTitle>
				<img src={Lock} /> {translations.savePayments}
				{PAYU_OPERATOR_COUNTRIES.includes(lang) && (
					<PaymentIcon src={Payu} style={{ width: '45px' }} />
				)}
				{[...STRIPE_SUBSCRIBTION, ...STRIPE_ONE_OFF].includes(lang) && (
					<PaymentIcon src={Stripe} style={{ width: '45px' }} />
				)}
				{[...PADDLE_ONE_OFF].includes(lang) && (
					<PaymentIcon
						src={Paddle}
						style={{ width: '90px', marginLeft: '-15px' }}
					/>
				)}
			</PaymentTitle>
			<ImageWrapper>
				{PAYMENTS_INFO_CONFIG.filter((i) => i.langs.includes(lang)).map((i) => (
					<PaymentIcon src={i.image} style={{ width: '40px' }} />
				))}
			</ImageWrapper>
		</>
	);
};

export default SavePayment;
